import { AddListItemButton } from 'components/atoms';
import { EmptyTreatmentPrescription } from 'components/atoms/treatmentConsultation/EmptyTreatmentPrescription';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ICreateTreatmentConsultation } from 'types';

import { Stack, StackProps } from '@mui/material';

import { TreatmentPrescriptionExamItem } from '../TreatmentPrescriptionExamItem';
import { TreatmentPrescriptionMedicamentItem } from '../TreatmentPrescriptionMedicamentItem';
import { useTreatmentConsultation } from 'context';

export const TreatmentPrescriptionList: React.FC<StackProps> = (props) => {
  const { exams } = useTreatmentConsultation();
  const { control } = useFormContext<ICreateTreatmentConsultation>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'prescription',
  });

  const handleAddMedicament = () => {
    append({
      type: 'medicament',
      name: '',
      posology: '',
      way: '',
      quantity: '',
    });
  };

  const handleAddExam = () => {
    append({ type: 'exam', name: '', indication: '' });
  };

  const handleRemove = (index: number) => () => {
    remove(index);
  };

  return (
    <Stack spacing={2} {...props}>
      {!fields.length && <EmptyTreatmentPrescription />}

      {fields.map((item, index) =>
        item?.type === 'medicament' ? (
          <TreatmentPrescriptionMedicamentItem
            key={index}
            onDeleteClick={handleRemove(index)}
            index={index}
          />
        ) : (
          <TreatmentPrescriptionExamItem
            key={index}
            onDeleteClick={handleRemove(index)}
            index={index}
            exams={exams}
          />
        )
      )}

      <Stack direction="row" spacing={2} justifyContent="flex-end" pb={1}>
        <AddListItemButton onClick={handleAddMedicament}>
          Adicionar Medicamento
        </AddListItemButton>

        <AddListItemButton onClick={handleAddExam}>
          Adicionar Exame
        </AddListItemButton>
      </Stack>
    </Stack>
  );
};
